(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lt3d-page"] && !Shopify.designMode) return;
  try {
    
  function lt3dBuildOutline(scope) {
    scope.querySelectorAll('.lt3d-page__layout').forEach(layout => {
      const nav = layout.querySelector('[data-lt3d-outline]');
      const article = layout.querySelector('[data-lt3d-article]');
      if (!nav || !article || nav.dataset.ready) return;
      const headings = [...article.querySelectorAll('h2')];
      if (headings.length < 3) return;
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = 'lt3d-section-' + (index + 1);
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        nav.append(link);
      });
      nav.dataset.ready = 'true';
      nav.hidden = false;
    });
  }
  lt3dBuildOutline(document);
  document.addEventListener('shopify:section:load', event => lt3dBuildOutline(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt3d-variant-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__lt3dContentClicks || window.Shopify?.designMode) return;
  window.__lt3dContentClicks = true;

  const models = new Set(['winmau-v1', 'winmau-v2', 'target-corona']);
  const products = new Set([
    'autodarts-kameraset-winmau-plasma-ov9732',
    'kamerahalter-autodarts-winmau-plasma-ohne-kameras',
    'autodarts-winmau-plasma-v1-mit-kameras',
    'autodarts-winmau-plasma-v1-ohne-kameras',
    'autodarts-target-corona-mit-kameras',
    'autodarts-target-corona-ohne-kameras'
  ]);
  const offerActions = new Set(['offer_button', 'offer_image', 'offer_title']);

  document.addEventListener('click', (event) => {
    try {
      if (!event.isTrusted || event.button !== 0) return;
      const link = event.target?.closest?.('a[data-lt3d-action]');
      if (!link || !link.closest('.lt3d-variant')) return;
      const pageMatch = window.location.pathname.match(/^\/(?:en\/)?pages\/(winmau-v1|winmau-v2|target-corona)\/?$/);
      if (!pageMatch || window.location.origin !== 'https://lt3darts.com') return;
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy?.analyticsProcessingAllowed?.() !== true || typeof window.gtag !== 'function') return;

      const action = link.dataset.lt3dAction;
      const target = new URL(link.getAttribute('href'), window.location.href);
      if (target.origin !== window.location.origin) return;
      let contentId = link.dataset.lt3dContent;
      if (offerActions.has(action)) {
        if (!products.has(contentId) || !new RegExp('^/(?:en/)?products/' + contentId + '/?$').test(target.pathname)) return;
      } else if (action === 'model_switch') {
        if (!models.has(contentId) || !new RegExp('^/(?:en/)?pages/' + contentId + '/?$').test(target.pathname)) return;
      } else if (action === 'choose_set' || action === 'setup_details') {
        const prefix = action === 'choose_set' ? '#lt3d-variant-products-' : '#lt3d-variant-details-';
        if (target.pathname !== window.location.pathname || !target.hash.startsWith(prefix)) return;
        contentId = pageMatch[1];
      } else {
        return;
      }

      window.gtag('event', 'select_content', {
        send_to: 'G-6Y18RR7R97',
        content_type: 'lt3d_' + action,
        content_id: contentId,
        page_location: window.location.origin + window.location.pathname,
        page_referrer: '',
        page_title: 'LT3Darts ' + pageMatch[1]
      });
    } catch (_) {}
  }, { capture: true, passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt3d-videoaktion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lt3d-campaign-simple')) {
  customElements.define('lt3d-campaign-simple', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const form = this.querySelector('form');
      const body = this.querySelector('[data-body]');
      if (form && body) {
        const baseMessage = body.value;
        form.addEventListener('submit', () => {
          const timestamp = new Date().toISOString();
          const idField = this.querySelector('[data-submission-id]');
          if (!idField.value) {
            idField.value = window.crypto && typeof window.crypto.randomUUID === 'function'
              ? window.crypto.randomUUID()
              : 'ugc-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
          }
          this.querySelector('[data-timestamp]').value = timestamp;
          body.value = [
            baseMessage,
            'Einreichung-ID: ' + idField.value,
            'Zeitpunkt UTC: ' + timestamp,
            'Zuordnung: ' + form.elements['contact[Bestellnummer]'].value + ' – ' + form.elements['contact[name]'].value,
            'E-Mail: ' + form.elements['contact[email]'].value,
            'Kaufdatum (Kaufnachweis pruefen): ' + (this.querySelector('[data-purchase-date]').value || 'nicht angegeben'),
            'Bedingungen: ' + this.dataset.version,
            'Erklaerung 1: ' + this.querySelector('[data-terms]').closest('label').textContent.trim(),
            'Erklaerung 2: ' + this.querySelector('[data-consent]').closest('label').textContent.trim()
          ].join('\n\n');
        });
      }
      this.querySelector('[data-legal-open]')?.addEventListener('click', () => {
        this.querySelectorAll('[data-legal] details').forEach(detail => { detail.open = true; });
      });
      const result = this.querySelector('[data-server-success], [data-server-error]');
      if (result) {
        result.scrollIntoView({ block: 'center' });
        result.focus({ preventScroll: true });
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
